// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1711622256351
      var cssReload = require("/Users/dylankartutu/Local Sites/simon-dryers/app/wp-tummers/site/web/app/themes/tummersplaatbewerking.nl/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  